import { Module } from 'vuex'
import loginAuth from '@finance/login'
import init from '$utils/polyfill-ssjdata-in-cardniu'

const common: Module<any, any> = {
  state: {
    loading: false, // loading显示状态
    containerClass: '', // container Class
    refreshBtnVisiable: false, // 是否展示点击刷新按钮，一般在接口出错的时候展示
    loginState: false, // 登录状态
    custodyState: false, // 是否开了存管户状态
    isFetchSilentLoginState: false, // 是否已经调用过静默登录的接口请求
  },
  mutations: {
    showLoading(state) {
      state.loading = true
    },
    hideLoading(state) {
      state.loading = false
    },
    setContainerClass(state, containerClass) {
      state.containerClass = containerClass
    },
    showRefreshBtn(state) {
      state.refreshBtnVisiable = true
    },
    hideRefreshBtn(state) {
      state.refreshBtnVisiable = false
    },
    updateLoginState(state, payloay) {
      state.loginState = payloay
    },
    updateCustodyState(state, payloay) {
      state.custodyState = payloay
    },
    updateSilentLoginState(state) {
      state.isFetchSilentLoginState = true
    }
  },
  actions: {
    // 静默登录
    slientLogin({ commit, state }, forceUpdate = false) {
      if (state.isFetchSilentLoginState && !forceUpdate) {
        return state.loginState ? Promise.resolve() : Promise.reject()
      }

      return new Promise((resolve, reject) => {
        loginAuth.login({
          type: loginAuth.loginTypes.silent,
          success: ({
            isLogin = false, // 是否登录(说明，这个字段在设置isNeedUserData为false的情况下也会返回)
          }) => {
            console.log('调用静默登录', isLogin)
            commit('updateSilentLoginState')
            commit('updateLoginState', isLogin)
            if (isLogin) {
              resolve(true)
            } else {
              reject()
            }
          },
          error: (err: any) => {
            console.warn('静默登录出错', err)
            reject()
          } // 登录失败的回调方法，会传出报错信息
        })
      })
    },
    // 正常登录
    normalLogin({ commit, state }) {
      if (state.loginState) {
        return Promise.resolve()
      }

      return new Promise((resolve, reject) => {
        loginAuth.login({
          success: ({
            isLogin = false, // 是否登录(说明，这个字段在设置isNeedUserData为false的情况下也会返回)
          }) => {
            commit('updateLoginState', isLogin)
            if (isLogin) {
              init().then(() => resolve(true))
            } else {
              reject()
            }
          },
          error: (err: any) => {
            console.warn('正常登录出错', err)
            reject()
          },
          cancel: () => {
            reject()
          }
        })
      })
    },
  }
}

export default common
